module.exports = __webpack_public_path__ + "static/media/filePreviewIcon.15f5eab1.svg";